// Angular
import { Component, Output, EventEmitter, OnInit, Input } from '@angular/core';
// Models
// Services
import { ElasticService } from './../../services/elastic';
// External
import * as lodash from 'lodash';


import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { ElementRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Subject } from "rxjs/Subject";

@Component({
    selector: 'app-tournament-select',
    templateUrl: './tournament-select.component.html',
    styleUrls: ['./tournament-select.component.scss']
})

export class TournamentSelectComponent implements OnInit {

    @Output() onChange: EventEmitter<any>;

    public query: string;
    public clubs: Array<any>;
    public selectedTournaments: Array<any>

    private typingDelay: any;
    //chips
    @Input() parentSubject: Subject<any>;

    visible = true;
    selectable = true;
    removable = true;
    addOnBlur = true;
    separatorKeysCodes: number[] = [ENTER, COMMA];
    fruitCtrl = new FormControl();
    filteredFruits: Observable<string[]>;
    public fruits: any[] = [];
    allFruits: any[] = []

    @ViewChild('fruitInput', { read: true }) fruitInput: HTMLInputElement;
    @ViewChild('auto', { read: true }) matAutocomplete: MatAutocomplete;

    constructor(private elasticSearch: ElasticService) {
        this.onChange = new EventEmitter();
        this.query = '';
        this.parentSubject = new Subject()
    }
    ngOnInit() {


        this.fruitCtrl.valueChanges.subscribe((res) => {
            this.changeQuery(res)
        })
        if (this.parentSubject) {
            this.parentSubject.subscribe(event => {
                if (event.selectedTournaments) {
                    for (let i = 0; i < event.selectedTournaments.length; i++) {
                        this.fruits.push(event.selectedTournaments[i])
                    }
                }
            })
        }

    }
    searchMention(query?) {
        if(typeof query != 'string'){
            return
        }
        let queryParams = {}
        queryParams = {
            'index': 'tournaments',
            'type': 'tournament',
            'size': 5,
            'body/sort/startDate/order': `desc`
        };

        if (query != undefined && query != "") {

            queryParams['body/query/bool/must/term/eventName'] = query
        }



        this.elasticSearch.search(queryParams)
            .then(result => {
                this.clubs = [];
                if (result && result['hits']) {
                    lodash.forEach(result['hits'], item => {
                        const club = lodash.assign({ $key: item['_id'] }, item['_source']);
                        this.clubs.push(club);
                    });

                }

            })
            .catch(error => {
                console.error(error);
            });
    }

    changeQuery(query?) {
        clearTimeout(this.typingDelay);

        this.onChange.emit();

        this.typingDelay = setTimeout(() => {
            this.searchMention(query);
        }, 400);
    }

    onFocus() {
        this.searchMention();
    }

    onBlur() {
        setTimeout(() => {
            this.clubs = [];
        }, 500);
    }

    chooseClub(club: any) {
        this.query = "";
        this.clubs = [];
    }
    add(event: MatChipInputEvent): void {
        // Add fruit only when MatAutocomplete is not open
        // To make sure this does not conflict with OptionSelected Event
        if (this.matAutocomplete && !this.matAutocomplete.isOpen) {
            const input = event.input;
            const value = event.value;

            // Add our fruit
            if ((value || '').trim()) {
               
            }

            // Reset the input value
            if (input) {
                input.value = '';
            }

            this.fruitCtrl.setValue(null);
        }
    }

    remove(fruit: string): void {
        const index = this.fruits.indexOf(fruit);

        if (index >= 0) {
            this.fruits.splice(index, 1);
            this.onChange.emit(this.fruits);

        }

    }

    selected(event: MatAutocompleteSelectedEvent): void {
        // this.fruitInput.value = '';
        let i = this.fruits.findIndex(x => x.$key == event.option.value.$key)


        if (i == -1) {
            this.fruits.push(event.option.value);
            this.fruitCtrl.setValue(null);
            this.fruitCtrl.patchValue("")
            this.onChange.emit(this.fruits);
        } else {
           this.remove(event.option.value)
        }
      

    }


}
